'use strict';

var FareChangeGridDirective = function FareChangeGridDirective(hepService) {
  return {
    restrict: 'E',
    template: require('../templates/fare-change-grid.html'),
    replace: true,
    controller: 'FareChangeGridController',
    link: function link(scope) {
      scope.$on('Chart:SnapshotDates:selectedSnapshotDate', function () {
        scope.onSelectSnapshotDate.apply(scope, arguments);
      });
      scope.$on('SnapshotDatesChart:changeLegend:metrics', function () {
        scope.onChangeMetric.apply(scope, arguments);
      });
      scope.$on('context-menu:fare-change-grid', function (event, eventData) {
        scope.onContextMenuClick(eventData);
      });
      hepService.retrieveSimpleHepProperties('DynamicAvailability').then(function (properties) {
        scope.hostCurrencyLabel = '(' + properties['HOST_CARRIER_CURRENCY'] + ')';
      });
    }
  };
};
FareChangeGridDirective.$inject = ['HepService'];
module.exports = FareChangeGridDirective;